import toast from 'features/toast';
import { IContractLine } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from './BaseService';

class ContractLineService extends BaseService<IContractLine> {
  constructor() {
    super('contract-lines');
  }
  canDelete = true;

  public async setStatus(id: number | string, status: string) {
    return axiosPrivate.patch(`${this.modulePrefix}/${id}/set-status/`, {
      status
    });
  }

  public async getSummary(id: number | string) {
    try {
      const res = await axiosPrivate.get(`${this.modulePrefix}/${id}/get_summary/`);
      return res.data;
    } catch (e) {
      toast.error(e.message);
    }
  }

  importFromFileDetail = async (
    importFile: File,
    contractId: number,
    attachmentName = 'import_file'
  ) => {
    const res = await axiosPrivate.postForm(`contracts/${contractId}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    // Extract contractId from current URL
    const pathParts = window.location.pathname.split('/');
    const contractIndex = pathParts.findIndex(
      (part) => part === 'contracts' || part === 'contract'
    );
    if (contractIndex !== -1 && pathParts[contractIndex + 1]) {
      const contractId = parseInt(pathParts[contractIndex + 1], 10);
      if (!isNaN(contractId)) {
        return this.importFromFileDetail(importFile, contractId, attachmentName);
      }
    }
    throw new Error('Contract ID not found in URL');
  };
}

export const contractLineService = new ContractLineService();
